(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('SectionTypeDetailController', SectionTypeDetailController);

    SectionTypeDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'SectionType', 'User'];

    function SectionTypeDetailController($scope, $rootScope, $stateParams, previousState, entity, SectionType, User) {
        var vm = this;

        vm.sectionType = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('trakeyeApp:sectionTypeUpdate', function(event, result) {
            vm.sectionType = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
